import { Auth } from '@nackle/bridge';
import { idURL } from './utils/endpoints';

const auth = new Auth( {
    authority: idURL,
    debug: false
} );

export default auth;

/**
 * hasPermission checks if the users auth claims has the permission
 *
 * @param permission
 * @returns {boolean|*}
 */
export function hasPermission( permission ) {
    const [ app, key ] = permission.split( '.', 2 );

    const userPermissions = auth?.state?.claims?.permissions;
    if ( !userPermissions ) {
        return false;
    }
    const appPermissions = userPermissions[ app ];
    if ( !Array.isArray( appPermissions ) ) {
        return false;
    }
    return appPermissions.includes( key );
}

/**
 * permissions the list of permissions available with gantry
 *
 * @type {{READ_PERMISSION_TAGS: string, DELETE_PERMISSION_TAGS: string, LIST_DATA_SOURCES: string, LIST_TABLES: string, DELETE_TABLES: string, READ_DATA_SOURCES: string, EDIT_DATA_SOURCES: string, CREATE_TABLES: string, LIST_PERMISSION_TAGS: string, EDIT_PERMISSION_TAGS: string, READ_TABLES: string, CREATE_DATA_SOURCES: string, CREATE_PERMISSION_TAGS: string, EDIT_TABLES: string, DELETE_DATA_SOURCES: string}}
 */
export const permissions = {
    CREATE_DATA_SOURCES: 'gantry-data-catalog.create-data-sources',
    READ_DATA_SOURCES: 'gantry-data-catalog.read-data-sources',
    EDIT_DATA_SOURCES: 'gantry-data-catalog.edit-data-sources',
    LIST_DATA_SOURCES: 'gantry-data-catalog.list-data-sources',
    DELETE_DATA_SOURCES: 'gantry-data-catalog.delete-data-sources',
    CREATE_TABLES: 'gantry-data-catalog.create-tables',
    READ_TABLES: 'gantry-data-catalog.read-tables',
    EDIT_TABLES: 'gantry-data-catalog.edit-tables',
    LIST_TABLES: 'gantry-data-catalog.list-tables',
    DELETE_TABLES: 'gantry-data-catalog.delete-tables',
    CREATE_PERMISSION_TAGS: 'gantry-data-catalog.create-permission-tags',
    READ_PERMISSION_TAGS: 'gantry-data-catalog.read-permission-tags',
    EDIT_PERMISSION_TAGS: 'gantry-data-catalog.edit-permission-tags',
    LIST_PERMISSION_TAGS: 'gantry-data-catalog.list-permission-tags',
    DELETE_PERMISSION_TAGS: 'gantry-data-catalog.delete-permission-tags'

};
